import { render, staticRenderFns } from "./CustomerCenterInfo.vue?vue&type=template&id=79fc5b1e&scoped=true"
import script from "./CustomerCenterInfo.vue?vue&type=script&lang=ts"
export * from "./CustomerCenterInfo.vue?vue&type=script&lang=ts"
import style0 from "./CustomerCenterInfo.vue?vue&type=style&index=0&id=79fc5b1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fc5b1e",
  null
  
)

export default component.exports